import { Doughnut, mixins } from 'vue-chartjs'
import Chart from 'chart.js'

const { reactiveProp } = mixins

Chart.plugins.unregister('labels')

export default {
  extends: Doughnut,
  mixins: [reactiveProp],
  props: {
    chartData: {
      type: Object,
      default: null
    },
    options: {
      type: Object,
      default: null
    }
  },
  mounted () {
    // this.chartData is created in the mixin.
    // If you want to pass options please create a local options object
    this.renderChart(this.chartData, this.options)
  }
}



// WEBPACK FOOTER //
// ./src/components/ReportActivity/ChartDouhdonutUseActivityBaseB.js